// Supported languages with native names
export const SUPPORTED_LANGUAGES = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "pt", name: "Português" },
  { code: "de", name: "Deutsch" },
  { code: "it", name: "Italiano" },
  { code: "nl", name: "Nederlands" },
  { code: "pl", name: "Polski" },
  { code: "sv", name: "Svenska" },
  { code: "no", name: "Norsk" },
  { code: "da", name: "Dansk" },
  { code: "fi", name: "Suomi" },
  { code: "ru", name: "Русский" },
  { code: "tr", name: "Türkçe" },
  { code: "ar", name: "العربية" },
  { code: "hi", name: "हिंदी" },
  { code: "zh-CN", name: "中文（简体）" },
  { code: "zh-TW", name: "中文（繁體）" },
  { code: "ko", name: "한국어" },
  { code: "ja", name: "日本語" },
  { code: "uk", name: "Українська" },
  { code: "tl", name: "Filipino" },
  { code: "th", name: "ไทย" },
  { code: "vi", name: "Tiếng Việt" },
  { code: "id", name: "Bahasa Indonesia" },
  { code: "ro", name: "Română" },
  { code: "hu", name: "Magyar" },
  { code: "cs", name: "Čeština" },
  { code: "el", name: "Ελληνικά" },
  { code: "he", name: "עברית" },
] as const;

export type LanguageCode = typeof SUPPORTED_LANGUAGES[number]["code"];

// Right-to-left languages
export const RTL_LANGUAGES: LanguageCode[] = ["ar", "he"];

export const isRTL = (code: string): boolean => {
  return RTL_LANGUAGES.includes(code as LanguageCode);
};

export const getLanguageName = (code: string): string => {
  const lang = SUPPORTED_LANGUAGES.find(l => l.code === code);
  return lang?.name || code;
};

export const isValidLanguageCode = (code: string): code is LanguageCode => {
  return SUPPORTED_LANGUAGES.some(l => l.code === code);
};

// LocalStorage key for language preference
export const LANGUAGE_STORAGE_KEY = "preferred_language";

export const getStoredLanguage = (): LanguageCode => {
  if (typeof window === "undefined") return "en";
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (stored && isValidLanguageCode(stored)) {
    return stored;
  }
  return "en";
};

export const setStoredLanguage = (code: LanguageCode): void => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
};
